<template>
  <Section id="step-one">
    <Counter>1</Counter>
    <Heading>Obtain your Discord token from Discord app</Heading>
    <Description>
      Please follow these instructions: <strong><a href="https://discordhelp.net/discord-token">How to find your Discord token</a></strong>.
      <br>
      <br>
      <div class="warning">
        <strong>Note:</strong> Anyone who knows your Discord token has full access to your account. Do not share it with anyone.
      </div>
    </Description>
    <Description>
      <div class="video">
        <div style="position: relative; padding-bottom: 67.28971962616822%; height: 0;">
          <iframe src="https://www.loom.com/embed/fa24f64eef0e4eb7a7e48781374736e8" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;">
          </iframe>
        </div>
      </div>
    </Description>
  </Section>
</template>

<script>
  import Section from './UI/Section'
  import Heading from './UI/Heading'
  import Description from './UI/Description'
  import Counter from './UI/Counter'
  import Action from './UI/Action'

  export default {
    components: {
      Section,
      Heading,
      Description,
      Counter,
      Action,
    }
  }
</script>

<style lang="scss" scoped>
  .video {
    margin-top: 30px;
    border-radius: 4px;
    overflow: hidden;
  }
</style>
